import pim from "../../imagens/pim.png"

import {QRCodeSVG} from 'qrcode.react';
import { Button } from "antd";
import { toast } from "react-toastify";

import "./style.css"


export function GerarPix({pixBase64, qrCode, setQrCode, valor}) {

  const copyToClipboard = () => {
    if (!qrCode) {
      toast.warning("Não há código para copiar.");
      return;
    }
  
    const tempInput = document.createElement("textarea");
    tempInput.value = qrCode;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
  };
  
  
  

  return (
    <div className="pix-container">
      <div className="qr-container">
        <QRCodeSVG
          value={qrCode}
          title="QR Code"
          size={160}
          bgColor="#ffffff"
          fgColor="#000000"
          level="M"
          imageSettings={{
            src: pim,
            height: 40,
            width: 40,
            excavate: true,
          }}
        />
      </div>

      <div className="valor">R$ {valor}</div>

      <textarea
        className="qr-input"
        value={qrCode}
        onChange={(e) => setQrCode(e.target.value)}
      />

      <Button className="copy-button" onClick={copyToClipboard}>
        Copiar código
      </Button>
    </div>
  );
}

export default GerarPix;
